import React from 'react';
import Button, { BOOKING_HREF } from '../Button/Button';
import './PersistentCTA.css';

const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
    <path
      d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1Zm12 8H5v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9ZM6 6a1 1 0 0 0-1 1v1h14V7a1 1 0 0 0-1-1H6Z"
      fill="currentColor"
    />
  </svg>
);

const PersistentCTA = () => (
  <div className="persistent-cta">
    <Button variant="persistent" href={BOOKING_HREF} icon={<CalendarIcon />}>
      Schedule a Free Consultation
    </Button>
  </div>
);

export default PersistentCTA;
